import { axiosApi } from "../../../../../api/dbAxios";

export const fetchRegulators = async () => {
  const test_email = "rborodinov@deloittece.com";
  try {
    const isLocalhost =
      typeof window !== "undefined" && window.location.hostname === "localhost";

    const response = await axiosApi.get(`/add_record/regulators/`, {
      params: isLocalhost ? { test_email } : {},
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching Regulators", error);
    return {};
  }
};
